(() => {
  'use strict';
  const root = document.querySelector('[data-trm-garage-final]');
  if (!root) return;
  const DRAFT_KEY = 'trmMyTruckGarageDraftV13Final';
  const EXACT_KEY = 'trmExactVehicleV2';
  let context = null;
  const read = (store, key) => { try { return JSON.parse(store.getItem(key) || 'null'); } catch (_) { return null; } };
  const id = () => `TRM-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2,8).toUpperCase()}`;
  const currentVehicle = () => {
    const sessionVehicle = read(sessionStorage, EXACT_KEY);
    if (sessionVehicle) return sessionVehicle;
    const legacyVehicle = read(localStorage, EXACT_KEY);
    if (legacyVehicle) sessionStorage.setItem(EXACT_KEY, JSON.stringify(legacyVehicle));
    return legacyVehicle;
  };
  const open = (detail = {}) => {
    const request = read(sessionStorage, 'trmFinderRequestV11') || {};
    const pdp = read(sessionStorage, 'trmFinderPdpContextV11') || {};
    const variant = Array.isArray(pdp.variants) ? (pdp.variants.find(v => String(v.id) === String(pdp.selectedVariantId)) || pdp.variants[0]) : null;
    context = { id:id(), source:detail.source || 'garage', finderKey:request.finderKey || pdp.finderKey || null, sku:variant?.sku || request?.pdpContext?.variants?.[0]?.sku || null, vehicle:currentVehicle(), request, createdAt:new Date().toISOString() };
    root.hidden = false;
    document.documentElement.classList.add('trm-garage-final-open');
    root.querySelector('[data-trm-garage-bed]')?.focus();
  };
  const close = () => { root.hidden = true; document.documentElement.classList.remove('trm-garage-final-open'); };
  root.querySelectorAll('[data-trm-garage-close]').forEach(el => el.addEventListener('click', close));
  window.addEventListener('trm:garage-open', e => open(e.detail));
  window.addEventListener('trm:fitment-request', e => {
    if (['CONDITIONAL_UNRESOLVED','SOURCE_CONFLICT'].includes(e.detail?.state)) open({source:'finder'});
  });
  root.querySelector('[data-trm-garage-form]')?.addEventListener('submit', event => {
    event.preventDefault();
    if (!event.currentTarget.reportValidity()) return;
    const bed = root.querySelector('[data-trm-garage-bed]')?.value || '';
    const other = root.querySelector('[data-trm-garage-bed-other]')?.value || '';
    const draft = {...context, customerReportedBedLength:bed === 'other_measured' ? other : bed, savedAt:new Date().toISOString()};
    sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
    const status = root.querySelector('[data-trm-garage-status]');
    if (status) { status.textContent = 'Saved for this browser session.'; status.hidden = false; }
    window.dispatchEvent(new CustomEvent('trm:garage-saved',{detail:draft}));
  });
})();